import React, { useEffect, useState } from 'react';

import { usePokCore } from '../../../common/hooks/usePokCore';

import { Option, Selector } from './Selector';

interface ClientGroupSelectorProps {
  value?: string | null;
  readOnly?: boolean;
  clearable?: boolean;
  onChange?: (option: Option | null) => void;
}

export const ClientGroupSelector: React.FC<
  ClientGroupSelectorProps
> = props => {
  const pok = usePokCore();
  const [name, setName] = useState<string>('');

  useEffect(() => {
    if (props.value) {
      void pok.clientGroups.getById(props.value).then(g => setName(g.name));
    } else {
      setName('');
    }
  }, [pok.clientGroups, props.value]);

  const provider = async (text: string) => {
    const groups = await pok.clientGroups.getAllByNamePattern(text);
    return groups.map(g => ({ value: g.id, label: g.name }) as Option);
  };

  return (
    <Selector
      uniqueKey={'cg-' + (props.value ?? 'new')}
      readOnly={props.readOnly}
      creatable={false}
      clearable={props.clearable}
      provider={provider}
      value={name}
      valueToShow={true}
      onChange={option =>
        props.onChange && props.onChange(option as Option | null)
      }
    />
  );
};
